import React, { useEffect, useRef, useState } from "react";
import QuestionItem from "../categories/QuestionItem";
import DynamicForm from "./DynamicForm";
import Questions from "./Questions";
import "./dynamicForm.scss";
import "./../categories/categories.scss";
import Appservice from "../../services/appservice";
import { AxiosError } from "axios";
import {
  getMappingList,
  getQuestionarieList,
} from "../../helpers/ServiceSections";
import MappingDynamicForm from "./MappingDynamicForm";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { RoutesEnum, SessionKeys } from "../../tsmodels/RoutesModel";
import { useNavigate, useParams } from "react-router-dom";
import { catchError } from "../../utils/Utils";
import Xarrow, { Xwrapper } from "react-xarrows";
import DropdownInput from "../../commonfields/inputs/DropdownInput";
import TextInput from "../../commonfields/inputs/TextInput";
import { ReactComponent as SearchIcon } from "../../images/search-icon.svg";
import { ReactComponent as BackIcon } from "../../images/back-icon.svg";
import { ReactComponent as DocEditIcon } from "../../images/doc-edit-icon.svg";
import { ReactComponent as DocIcon } from "../../images/doc-icon.svg";
import { IMappingModel } from "../../tsmodels/QuestionnaireModel";
import { IDropdownOptionsModel } from "../../tsmodels/SharedModel";
import { Nav, NavItem, NavLink } from "reactstrap";
import { cloneDeep } from "lodash";
import SpinnerModel from "../../commonfields/inputs/SpinnerModel";

interface Question {
  questionId: number;
  questionText: string;
}

interface Subcategory {
  subcategoryName: string;
  questions: Question[];
}

interface ParentCategory {
  questionId: number;
  parentCategoryName: string;
  subcategories: Subcategory[];
}

const MappingFields = (props: any) => {
  const { mappingId } = useParams();
  const navigate = useNavigate();
  /////ref//////
  const listRef = useRef<any>(null); // Ref for the List component
  const [questions, setQuestion] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [loader2, setLoader2] = useState<boolean>(false);
  const [fields, setFields] = useState<any>({});
  const [filteredFields, setFilteredFields] = useState<any>({});
  const service = new Appservice();
  const [open, setOpen] = useState<any>([]);
  const [selectedField, setSelectedField] = useState<any>();
  const [mappings, setMappings] = useState<any>({});
  const [activeCategory, setActiveCategory] = useState<string>("");
  const [allData, setAllData] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [selectedQuestion, setSelectedQuestion] = useState<any>("");
  const [questionnaireData, setQuestionnaireData] = useState<
    ParentCategory[] | []
  >([]);
  const [mappingDetails, setMappingDetails] = useState<IMappingModel | null>();
  const [questionSearch, setQuestionSearch] = useState("");
  const [fieldSearch, setFieldSearch] = useState("");
  const [documentSelected, setDocumentSelected] =
    useState<IDropdownOptionsModel | null>();
  const [activeMappingTab, setactiveMappingTab] = useState("all");
  const [validationModal, setvalidationModal] = useState(false);
  const [mappedValue, setMappedValue] = useState("");

  const [preSelectQuestions, setPreSelectQuestions] = useState<any>([]);
  const [selectedFieldId, setSelectedFieldId] = useState(null);

  // funcs - handlers

  const goBack = () => navigate(`/${RoutesEnum.MAPPINGS}`);

  const validationToggle = () => setvalidationModal(!validationModal);

  const toggle = (tab: string) => {
    if (activeMappingTab !== tab) {
      setactiveMappingTab(tab);
    }
  };

////Filter for field search/////

  const handleFieldSearch = (e: any) => {
    setFieldSearch(e?.target?.value);
  };
///Filter for Question search////
  const handleQuestionSearch = (e: any) => {
    setQuestionSearch(e?.target?.value);
    // e?.target?.value?.trim() && setQuestionnaireData(questionnaireData?.filter((q:any)=>q.questionText?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())));
  };

  // const handleDocumentSelection = (e: any) => {
  //   setDocumentSelected(e);
  // };

  const onFieldClick = (field: any) => {
    if (field) {
      setSelectedField(field);
    }
  };

  useEffect(() => {
    const _mappedfields = mappings[selectedQuestion] || [];

    let acrs: any = [];
    Object.keys(fields).forEach((k: any) => {
      if (fields[k].find((f: any) => _mappedfields.includes(f.id))) {
        acrs.push(k.replaceAll(" ", "@@"));
      }
    });
    setOpen(acrs);
    setSelectedFieldId(null);
    setPreSelectQuestions([]);
  }, [selectedQuestion]);

  // useEffect
  useEffect(() => {
    if (mappingId) {
      getMappingQuestion();
    }
  }, [mappingId]);

  useEffect(() => {
    getFieldsList();
  }, []);

  useEffect(() => {
    getFilteredFields();
  }, [activeMappingTab, fieldSearch]);
  /***
   * performed  fields mapped unmapped filters
   */
  const getFilteredFields = () => {
    const tempFields = cloneDeep(fields);
    if (
      activeMappingTab?.toLowerCase() === "mapped" ||
      activeMappingTab?.toLowerCase() === "unmapped"
    ) {
      const _fieldIds: any = [];
      Object.keys(mappings).forEach((fs: any) => {
        _fieldIds.push(...mappings[fs]);
      });
      if (activeMappingTab?.toLowerCase() === "mapped") {
        for (const f in tempFields) {
          tempFields[f] = tempFields[f]?.filter((f: any) => {
            if (_fieldIds.includes(f.id)) {
              return true;
            }
            return false;
          });
        }
      } else {
        for (const f in tempFields) {
          tempFields[f] = tempFields[f]?.filter((f: any) => {
            if (!_fieldIds.includes(f.id)) {
              return true;
            }
            return false;
          });
        }
      }
    }

    if (fieldSearch?.trim()) {
      for (const f in tempFields) {
        tempFields[f] = tempFields[f]?.filter((f: any) => {
          if (f.fieldName?.toLowerCase().includes(fieldSearch?.toLowerCase())) {
            return true;
          }
          return false;
        });
      }
    }

    setFilteredFields(tempFields);
  };

  const toggleAccordian = (id: any) => {
    if (open.includes(id)) {
      setOpen(open?.filter((item: any) => item !== id));
      // reRenderMappings();
    } else {
      setOpen([...open, id]);
      // reRenderMappings();
    }
    // setOpen({...open, [id]:!open[id]});
  };

  const getQuestionsList = () => {
    const payLoad =
      // {
      //   sections: "getCategoriesByQuestioanrieId",
      //   screen: "QuestionarieScreen",
      //   questionarieId: 12,
      //   isJsonReturnObject: true,
      // };
      {
        sections: "getQuestionarieFieldDataByDocId",
        screen: "QuestionarieScreen",
        documentId: mappingId,
        isJsonReturnObject: true,
        isJsonQuery: true,
      };
    setLoader(true);
    service
      .getQuestionsList(payLoad)
      .then((res) => {
        const categories = res.data || [];
        //const categories = questionsData;
        setAllData(categories);
        let drodownData: any = ["All"];
        categories?.forEach((c: any) => {
          drodownData?.push(c.parentCategoryName);
        });

        setCategories(drodownData);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const filterCategories = (parentcatg: any = "all") => {
    const catg = "All";

    setActiveCategory(parentcatg);

    let category: any =
      parentcatg?.toLowerCase() === "all"
        ? allData
        : allData.find((c: any) => c.parentCategoryName === parentcatg);
    let subcategories: any = [];
    if (parentcatg?.toLowerCase() === "all") {
      allData.forEach((cat: any) => {
        subcategories.push(...(cat.subcategories || []));
      });
    } else {
      subcategories = category?.subcategories;
    }
    let questions: any = [];

    subcategories?.forEach((subCatg: any) => {
      questions.push(...(subCatg.questions || []));
    });

    let m: any = {};
    for (let q: any = 0; q < questions.length; q++) {
      if (!questions[q]["fields"]) {
        continue;
      }
      if (!m[questions[q].questionId]) {
        m[questions[q].questionId] = [];
      }

      m[questions[q].questionId].push(
        ...questions[q].fields.map((f: any) => f.field_id)
      );
    }

    setQuestionnaireData(questions);
    setMappings(m);
  };

  const getFieldsList = async () => {
    const payLoad = {
      sections: "getVerifiedDocExtractedFields",
      screen: "QuestionarieScreen",
      documentId: mappingId,
      isJsonReturnObject: true,
      isJsonQuery: true,
    };

    setLoader(true);

    await service
      .getQuestionsList(payLoad)
      .then((res: any) => {
        if (res.data && res.data.length) {
          res.data[0].images = res?.data?.[0]?.images || [];
          res.data[0].images = res?.data?.[0]?.images?.map((i: any) => {
            if (i.image_size) {
              i.image_size = JSON.parse(
                i.image_size
                  .replaceAll('"', "'")
                  .replace("height", '"height"')
                  .replace("width", '"width"')
              );
            }
            return i;
          });

          res.data[0].fields = res?.data?.[0].fields || [];
          res.data[0].fields = res?.data?.[0].fields?.sort((a: any, b: any) =>a?.page-b?.page)
          ?.sort((a1: any, b1: any) =>a1?.sequenceNumber-b1?.sequenceNumber).map((f: any) => {
            if (f.coordinates) {
              f.coordinates = JSON.parse(
                f.coordinates
                  .replaceAll('"', "'")
                  .replace("h", '"h"')
                  .replace("w", '"w"')
                  .replace("x", '"x"')
                  .replace("y", '"y"')
              );
            }
            return f;
          });

          formatData(res.data?.[0]?.fields);
        }
      })

      .catch((error: AxiosError) => {
        // catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const formatData = (data: any) => {
    const result: any = {};
    let firstAccordian = "";
    data.forEach((d: any) => {
      if (d.section) {
        if (!firstAccordian) {
          firstAccordian = d.section?.replaceAll(" ", "@@");
        }
        result[d.section] = result[d.section] || [];
        result[d.section].push(d);
      } else {
        result["default"] = result["default"] || [];
        result["default"].push(d);
      }
    });
    setOpen([firstAccordian]);
    setFields(result);
    setFilteredFields(result);
  };

  const handleSelection = (
    leftField: any,
    rightField: any,
    operation = "add"
  ) => {
    if (operation === "remove") {
      let _mappings: any = cloneDeep(mappings);
      _mappings[leftField] = _mappings[leftField]?.filter(
        (f: any) => f !== rightField
      );
      setMappings(_mappings);
      setQuestionnaireData(
        questionnaireData.map((q: any) => {
          if (q.questionId === leftField) {
            q.fields = q.fields || [];
            q.fields = q.fields.filter((f: any) => f.field_id !== rightField);
          }
          return q;
        })
      );
    } else {
      setMappings((prev: any) => ({
        ...prev,
        [leftField]: prev[leftField]
          ? [...prev[leftField], rightField]
          : [rightField],
      }));
      setQuestionnaireData(
        questionnaireData.map((q: any) => {
          if (q.questionId === leftField) {
            q.fields = q.fields || [];
            q.fields.push({ field_id: rightField });
          }
          return q;
        })
      );
    }
    setSelectedQuestion(null);
  };
  const getMappingQuestion = () => {
    const payLoad = getMappingList;

    service
      .getQuestionnaireList(payLoad)
      .then((res: any) => {
        setMappingDetails(
          res.data?.find((each: any) => each?.mappingId === mappingId)
        );
      })

      .finally(() => {});
  };
  const saveExtractedFieldMappings = () => {
    setLoader2(true);
    service
      .saveExtreactedFieldMappings(mappingId)
      .then((res: any) => {
        // getMappingQuestion();
        getFieldsList();
        getQuestionsList();
        // setTimeout(()=>{
        //   getFieldsList();
        //   getQuestionsList();
        // }, 100);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader2(false);
      });
  };

  /////for generate button validation Api/////
  const validationMappings = () => {
    setLoader2(true);
    const payLoad = {
      sections: "getQuestionFieldMappingValidation",
      screen: "QuestionarieScreen",
      documentId: mappingId,
    };

    service
      .getValidation(payLoad)
      .then((res: any) => {
        setMappedValue(res.data[0]?.mapped);
        if (res.data[0]?.mapped) {
          setLoader2(false);
          setvalidationModal(true);
        } else {
          //setLoader2(false);
          saveExtractedFieldMappings();
        }
      })

      .catch((error: AxiosError) => {
        setLoader2(false);
        catchError(error, true);
      })
      .finally(() => {});
  };
///filter for Questions ///
  const filterQuestinaryData = (questions: any) => {
    let tempQuestions = cloneDeep(questions);
    let results = tempQuestions;

    if (questionSearch?.trim()) {
      results = tempQuestions.filter((f: any) => {
        if (
          f.questionText?.toLowerCase().includes(questionSearch?.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
    }

    if(preSelectQuestions && preSelectQuestions.length){
        return [...results.filter((r1:any)=>preSelectQuestions.includes(r1.questionId)),...results.filter((r1:any)=>!preSelectQuestions.includes(r1.questionId)) ]
    }

    return results;
  };
////Scroll to Question////
const scrollToField = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

  const scrollToQuestion = (questionId: number) => {
    const questionIndex = questionnaireData.findIndex(
      (q) => q.questionId === questionId
    );
    if (questionIndex !== -1 && listRef.current) {
      listRef.current.scrollToItem(questionIndex, 'start');
    }
  };

  const onSelectField = (id: any) => {
    // preSelectQuestions
    let result = [];
    setSelectedFieldId(id);
    const questionIds = Object.keys(mappings);
    for (let q = 0; q < questionIds.length; q++) {
      const fields = mappings[questionIds[q]] || [];
      if (fields.includes(id)) {
        result.push(+questionIds[q]);
      }
    }
    !selectedQuestion && setPreSelectQuestions(result);

      // Scroll to the first related question if one exists
      if (result.length > 0) {
        scrollToQuestion(result[0]);
      }
  };

  return (
    <>
      <div>
        <div className="subheader-container">
          <div className="subheader-left">
            <div className="subheader-icon" onClick={goBack}>
              <BackIcon />
            </div>
            <div className="subheader-title">
              {decodeURI(mappingDetails?.mappingName || "")}
            </div>
          </div>
          <div className="subheader-right">
            <Button
              disabled={loader2}
              className="generate-btn"
              onClick={validationMappings}
            >
              {loader2 ? (
                <SpinnerModel
                  value={""}
                  color={"primary"}
                  size={"sm"}
                  type={"border"}
                />
              ) : null}
              Generate
            </Button>
          </div>
        </div>

        <div className="subheader-container secondary">
          <div className="subheader-left">
            <div className="subheader-title">
              <span className="subheader-icon">
                <DocEditIcon />
              </span>
              {mappingDetails?.questionnaireName}
            </div>
            <div className="subheader-input-container">
              <TextInput
                className="subheader-input"
                value={questionSearch}
                onChange={handleQuestionSearch}
                placeholder="Search for question"
              />
              <SearchIcon className="search-icon" />
            </div>
          </div>
          <div className="subheader-divider"></div>
          <div className="subheader-right">
            <div className="document-mapping">
              {/* <div className="subheader-icon">
                <DocIcon />
              </div>
              <div className="mapping-questionnire">
                <DropdownInput
                  value={questionSearch}
                  disabled
                  //options={documentsMap}
                  placeholder="Select a Document"
                  onChange={handleDocumentSelection}
                />
              </div> */}
            </div>
            {/* <div className="document-divider"></div> */}
            <div className="subheader-input-container">
              <TextInput
                className="subheader-input"
                value={fieldSearch}
                onChange={handleFieldSearch}
                placeholder="Search for field"
              />
              <SearchIcon className="search-icon" />
            </div>
          </div>
        </div>
        <div className="mappings" style={{ position: "relative" }}>
          <div className="questions-mapping" style={{ position: "relative" }}>
            {/* {applicationData.map(question => (
        <Questions key={question.id} question={question} />
      ))} */}

            <Questions
              filterCategories={filterCategories}
              getQuestionsList={getQuestionsList}
              activeCategory={activeCategory}
              allData={allData}
              categories={categories}
              questionnaireData={filterQuestinaryData(questionnaireData)}
              setSelectedQuestion={setSelectedQuestion}
              fields={fields}
              preSelectQuestions={preSelectQuestions}
              selectedQuestion={selectedQuestion}
            />
          </div>

          <div className="mapping-dy" style={{ position: "relative" }}>
            <div className="miniFilterContainer">
              <div className="fields">FIELDS</div>
              <Nav pills>
                <NavItem>
                  <NavLink
                    className={activeMappingTab === "all" ? "active" : ""}
                    onClick={() => toggle("all")}
                  >
                    All
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeMappingTab === "mapped" ? "active" : ""}
                    onClick={() => toggle("mapped")}
                  >
                    Mapped
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeMappingTab === "unmapped" ? "active" : ""}
                    onClick={() => toggle("unmapped")}
                  >
                    Unmapped
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <div className="mapping-scroll">
              {fields["default"] && fields["default"]?.length ? (
                <MappingDynamicForm
                  initialFields={filteredFields["default"]}
                  onFieldClick={onFieldClick}
                  selectedField={selectedField}
                  handleSelection={handleSelection}
                  selectedQuestion={selectedQuestion}
                  mappedFields={mappings}
                  onSelectField={onSelectField}
                  selectedFieldId={selectedFieldId}
                />
              ) : (
                <></>
              )}
              {Object.keys(fields).length ? (
                <Accordion open={open} toggle={toggleAccordian}>
                  {Object.keys(fields).map((k: string) =>
                    k !== "default" ? (
                      <AccordionItem>
                        <AccordionHeader targetId={k.replaceAll(" ", "@@")}>
                          {k}<span className="fieldsCount">({filteredFields[k]?.length || 0})</span>
                        </AccordionHeader>
                        <AccordionBody accordionId={k.replaceAll(" ", "@@")}>
                          <MappingDynamicForm
                            initialFields={filteredFields[k]}
                            onFieldClick={onFieldClick}
                            selectedField={selectedField}
                            handleSelection={handleSelection}
                            selectedQuestion={selectedQuestion}
                            mappedFields={mappings}
                            onSelectField={onSelectField}
                            selectedFieldId={selectedFieldId}
                          />
                        </AccordionBody>
                      </AccordionItem>
                    ) : (
                      <></>
                    )
                  )}
                </Accordion>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={validationModal} toggle={validationToggle}>
        <ModalHeader toggle={validationToggle}>Alert </ModalHeader>
        <ModalBody>
          Regenerating the mapping will overwrite existing data
        </ModalBody>
        <ModalFooter>
          <Button
            className="ok-button"
            onClick={() => {
              setvalidationModal(false);
              saveExtractedFieldMappings();
            }}
          >
            Ok
          </Button>{" "}
          <Button color="secondary" onClick={() => setvalidationModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MappingFields;
